module.exports = __webpack_public_path__ + "img/17.1.26ff49b7.jpg";